import { Loader2 } from "lucide-react";

export default function CircularProgress() {
  return <Loader2 className="animate-spin text-brand h-12 w-12" />;
}
